export default __webpack_public_path__ + "0654f429118ef4c69cf8f0bc9ee40fe3.png";